import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { ServiceModuleConfig } from '@/types/service';
import { useAuth } from '@/contexts/AuthContext';

export function useServiceModuleConfig() {
  const { company } = useAuth();

  return useQuery<ServiceModuleConfig | null>({
    queryKey: ['service-module-config', company?.id],
    queryFn: async () => {
      if (!company?.id) return null;
      const { data, error } = await supabase
        .from('service_module_config')
        .select('*')
        .eq('company_id', company.id)
        .maybeSingle();
      if (error) throw error;
      return data as ServiceModuleConfig | null;
    },
    enabled: !!company?.id,
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpsertServiceModuleConfig() {
  const queryClient = useQueryClient();
  const { company } = useAuth();

  return useMutation({
    mutationFn: async (payload: Partial<ServiceModuleConfig>) => {
      if (!company?.id) throw new Error('company_id ausente');
      const { data, error } = await supabase
        .from('service_module_config')
        .upsert({ ...payload, company_id: company.id }, { onConflict: 'company_id' })
        .select()
        .single();
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['service-module-config', company?.id],
      });
    },
  });
}
